import moment from "moment";
import { addTrailingZeros } from "@js-app/services/helpers/math";
import {
  FINISH,
  IN_PROGRESS,
  PLACED,
  REGISTRY_COMPLETED,
} from "@js-app/const/operation-statuses-ids";

export default class PayoutsRegistry {
  constructor(payoutsRegistryData) {
    this.payoutsRegistryData = payoutsRegistryData;
  }

  get dateTime() {
    return {
      date: moment(this.payoutsRegistryData.date_create).format("DD.MM.YYYY"),
      time: moment(this.payoutsRegistryData.date_create).format("HH:mm:ss"),
    };
  }

  get datePlain() {
    return this.payoutsRegistryData.date_create;
  }

  get registryName() {
    return this.payoutsRegistryData.name || "";
  }

  get totalSum() {
    return addTrailingZeros(
      (parseInt(this.payoutsRegistryData.total_sum || 0) / 100).toLocaleString()
    );
  }

  get totalSumPlain() {
    return this.payoutsRegistryData.total_sum || 0;
  }

  get totalCount() {
    return parseInt(this.payoutsRegistryData.position_count || 0);
  }

  get status() {
    switch (this.statusPlain) {
      case "processing":
        return IN_PROGRESS;
      case "completed":
        return REGISTRY_COMPLETED;
      case "new":
      default:
        return PLACED;
    }
  }

  get statusPlain() {
    return this.payoutsRegistryData.status || "new";
  }

  // get id() {
  //   return this.payoutsRegistryData.id || Math.random();
  // }

  get id() {
    if (this.payoutsRegistryData.id) {
      return this.payoutsRegistryData.id;
    }

    const array = new Uint32Array(1);
    window.crypto.getRandomValues(array);

    return array[0];
  }
}
